export default {
    data() {
        return {
            radios: [1, 2, 3],
            radioSeleccionado: '',
            distancias: [],
        };
    },
    watch: {
        radioSeleccionado(nuevoValor) {
            const distanciasActuales = [...this.distancias];
            if (nuevoValor < distanciasActuales.length) {
                this.distancias = distanciasActuales.slice(0, nuevoValor);
            } else if (nuevoValor > distanciasActuales.length) {
                const faltantes = Array.from({ length: nuevoValor - distanciasActuales.length }, () => 0);
                this.distancias = distanciasActuales.concat(faltantes);
            }
            this.emitState();
        },
    },
    methods: {
        updateDistancia(index, value) {
            const num = Number(value);
            this.$set(this.distancias, index, num);

            clearTimeout(this.emitTimeout);
            this.emitTimeout = setTimeout(() => {
                const distanciasValidas = this.distancias.filter((v) => v > 0);
                if (distanciasValidas.length > 0) {
                    this.$emit('generateRings', { distances: distanciasValidas });
                }
                this.emitState();
            }, 600);
        },
    },
};
